import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../contexts/UserContext';
import { useNavigate, useParams } from 'react-router-dom';
import { providersPathTo } from '../utils/Api';
import SnackbarContext from '../contexts/SnackbarContext';
import TagList from './TagList';
import { Avatar, Box, Button, Divider, Typography } from '@mui/material';
import { apiBaseUrl } from '../utils/Api/Api';
import { ShoppingCartProductsContext } from '../contexts/ShoppingCartProductsContext';
import ProductsTagFilters from './ProductsTagFilters';
import { ArrowBackRounded } from '@mui/icons-material';
import { ShopProductList } from '.';
import ShoppingCartElement from './building_blocks/ShoppingCartElement';
import { layoutIconButtonRadius, layoutShopSheetRadius } from '../theme/colors';

function ProviderShop() {
  const { id } = useParams();
  const [provider, setProvider] = useState();
  const [tagFilter, setTagFilter] = useState([]);
  const { shoppingCartProducts, setShoppingCartProducts } = useContext(ShoppingCartProductsContext);
  const navigate = useNavigate();
  const { openSnackbar } = useContext(SnackbarContext);

  const handleAddProduct = (product, index) => {
    if (shoppingCartProducts.length > 0 && shoppingCartProducts[0].provider_id !== product.provider_id) {
      openSnackbar('Você não pode adicionar produtos de lojas diferentes ao carrinho', 'info');
      return;
    }
    const newCartProduct = {
      ...product,
      cartQuantity: 1,
      productIndex: index
    };
    setShoppingCartProducts([...shoppingCartProducts, newCartProduct]);
    localStorage.setItem('shoppingCartProducts', JSON.stringify([...shoppingCartProducts, newCartProduct]));
    localStorage.setItem('shoppingProvider', JSON.stringify(provider));
  };

  const changeCartQuantity = (id, operation) => {
    let newShoppingCartProducts = [...shoppingCartProducts];
    const cartProduct = shoppingCartProducts.find(product => product.id === id);
    if (operation === '+') {
      if (cartProduct.quantity === 0 || (cartProduct.cartQuantity < cartProduct.quantity))
        cartProduct.cartQuantity += 1;
    } else {
      cartProduct.cartQuantity -= 1;
    }
    if (cartProduct.cartQuantity < 1) {
      var index = newShoppingCartProducts.findIndex(item => item.id === id);
      newShoppingCartProducts.splice(index, 1);
    }
    setShoppingCartProducts(newShoppingCartProducts);
    localStorage.setItem('shoppingCartProducts', JSON.stringify(newShoppingCartProducts));
  };

  useEffect(() => {
    if (id) {
      providersPathTo.provider_with_products({ id: id }).then(result => {
        setProvider(result.data);
      });
    }
  }, []);

  useEffect(() => {
    if (!provider) {
      return;
    }
    document.title = `${provider.name} - TudoPets.app`;
  }, [provider]);

  if (!provider) {
    return <div>Carregando...</div>;
  }

  const filteredProducts = provider.products.filter(product => tagFilter.length === 0 || tagFilter.every(selectedTag => product.tags.some(productTag => productTag.id === selectedTag.id)));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 'calc(100vh - 32px)' }}>
      {/* {provider.business_banner &&
        <Box sx={{ width: "calc(100% + 32px)", margin: "-16px", marginBottom: "16px", height: "140px" }}>
          <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={`${apiBaseUrl}${provider.business_banner}`} />
        </Box>
      } */}
      <Box id="shop-top" sx={{ alignItems: 'center', display: 'flex', justifyContent: 'flex-start' }}>
        <Button data-no-shadow="true" onClick={() => window.history.back()} sx={{ marginLeft: '-8px', color: 'text.primary', borderRadius: layoutIconButtonRadius }}>
          <ArrowBackRounded />
        </Button>

      </Box>
      <Box id="shop-main" sx={{ display: 'flex', alignItems: 'center', borderRadius: `${layoutShopSheetRadius} ${layoutShopSheetRadius} 0 0`, bgcolor: 'surface.card', flex: 1, flexDirection: 'column', alignSelf: 'stretch', justifyContent: 'flex-start', width: { xs: 'calc(100% + 32px)', sm: '100%' }, mx: { xs: -2, sm: 0 } }}>
        <Avatar sx={{ border: '1px solid lightgray', width: '80px', height: '80px', marginTop: '-32px', bgcolor: '#CFD8DC' }} src={provider.business_logo && `${apiBaseUrl}${provider.business_logo}`} />
        <Box sx={{
          mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px'
        }}>
          <Typography variant="pageTitle"><b>{provider.name}</b></Typography>
          <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: 400, lineHeight: '24px', color: '#546E7A' }}>
            <small>1,5km &#9679; Entrega em até 24h &#9679; R$10,00</small>
          </Typography>
          <Typography color="primary" onClick={() => navigate('/shop_info/', { state: provider })}
            sx={{
              fontFamily: 'Nunito', fontSize: '16px', fontWeight: 400, lineHeight: '14px', textDecorationLine: 'underline',
              textDecorationStyle: 'solid',
              textDecorationSkipInk: 'auto',
              textDecorationThickness: 'auto',
              textUnderlineOffset: '3px',
              textUnderlinePosition: 'from-font',
              cursor: 'pointer'
            }}>Ver perfil</Typography>
        </Box>

        {/*Manter?
        <Divider><Typography color="primary"><b>Produtos</b></Typography></Divider>

        <ProductsTagFilters tagFilter={tagFilter} setTagFilter={setTagFilter} tags={provider.tags} numProducts={filteredProducts.length} />*/}

        <ShopProductList
          products={filteredProducts}
          shoppingCartProducts={shoppingCartProducts}
          handleAddProduct={handleAddProduct}
          changeCartQuantity={changeCartQuantity}
          provider={provider}
        />
      </Box>
      <ShoppingCartElement />
    </Box>
  );
}

export default ProviderShop;
